import classnames from 'classnames'
import { Fabric } from 'office-ui-fabric-react/lib/Fabric'
import * as React from 'react'
// uncomment the below line when we want to enable open in OneNote banner
// import { isEdgeHubQueryParamPresent } from '../../lib/urlParserUtils'
import { ConsentBanner } from '../ConsentBanner'
import { ExportDialog } from '../ExportDialog'
import { Header } from '../Header'
// uncomment the below line when we want to enable open in OneNote banner
// import { OpenInApp } from '../OpenInApp/OpenInApp'
import * as css from './app.css'
import { PropsFromDispatch, PropsFromState, PropsPassedIn } from './props'

export const STICKY_NOTES_CANVAS_ID = 'stickyNotesCanvas'

type Props = PropsFromState & PropsFromDispatch & PropsPassedIn

export class App extends React.PureComponent<Props> {
  render(): JSX.Element {
    const { inMobileDetailView, authType, showHeader } = this.props
    const o365HeaderFrameClass = classnames(css.topContainer, inMobileDetailView ? css.hidden : null)
    const shellHeaderFrame = <div id='TopContainerArea' className={ o365HeaderFrameClass }><div id='TopContainer' /></div>
    // uncomment the below line when we want to enable open in OneNote banner
    // const isEdgeHub = isEdgeHubQueryParamPresent()

    // The shell header frame will be rendered if the user is authenticated, otherwise we'll render our stub header
    const header = authType ? shellHeaderFrame : <Header />

    return (
      <Fabric className={ css.fabricContainer }>
        <div className={ css.app }>
          <ExportDialog
            authType={ authType } />
          { showHeader ? header : null }
          <ConsentBanner />
          <div className={ css.mainContent }>
            <div
              role='main'
              id={ STICKY_NOTES_CANVAS_ID } />
          </div>
        </div>
      { /* uncomment the below line when we want to enable open in OneNote banner */ }
      { /* { isEdgeHub ? <OpenInApp /> : undefined } */ }
      </Fabric>
    )
  }
}
